import { render, staticRenderFns } from "./love.vue?vue&type=template&id=6f79d23a&scoped=true"
import script from "./love.vue?vue&type=script&lang=js"
export * from "./love.vue?vue&type=script&lang=js"
import style0 from "./love.vue?vue&type=style&index=0&id=6f79d23a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f79d23a",
  null
  
)

export default component.exports